import React, { useState } from "react";

type Reason = "pas_ambience" | "no_access" | "more_money";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: Reason, counterAmount?: number) => void;
}

const DeclineModal: React.FC<Props> = ({ isOpen, onClose, onConfirm }) => {
  const [reason, setReason] = useState<Reason>("pas_ambience");
  const [counterAmount, setCounterAmount] = useState<string>("");

  if (!isOpen) return null;

  const handleConfirm = () => {
    const num = Number(counterAmount);
    if (reason === "more_money" && (!counterAmount || isNaN(num) || num <= 0)) {
      alert("Please enter a valid amount");
      return;
    }
    onConfirm(reason, reason === "more_money" ? num : undefined);
  };

  return (
    <div className="decline-modal-overlay" onClick={onClose}>
      <div className="decline-modal" onClick={(e) => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>Why are you declining?</h3>

        <div className="decline-options">
          <label
            className={`decline-option ${
              reason === "pas_ambience" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name="decline-reason"
              checked={reason === "pas_ambience"}
              onChange={() => setReason("pas_ambience")}
            />
            <span>Not the vibe</span>
          </label>

          <label
            className={`decline-option ${
              reason === "no_access" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name="decline-reason"
              checked={reason === "no_access"}
              onChange={() => setReason("no_access")}
            />
            <span>I don’t have access to the song</span>
          </label>

          <label
            className={`decline-option special ${
              reason === "more_money" ? "active" : ""
            }`}
          >
            <input
              type="radio"
              name="decline-reason"
              checked={reason === "more_money"}
              onChange={() => setReason("more_money")}
            />
            <span>Request a higher amount</span>
          </label>

          {reason === "more_money" && (
            <div className="counter-block">
              <label>New amount ($):</label>
              <input
                type="number"
                inputMode="numeric"
                min={1}
                value={counterAmount}
                onChange={(e) => setCounterAmount(e.target.value)}
              />
              <small>
                The requester will see this amount and can choose to pay again.
              </small>
            </div>
          )}
        </div>

        <div className="decline-actions">
          <button className="decline-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="decline-confirm" onClick={handleConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclineModal;
